<template>
  <div>
    <div class="wrpper" v-for="(item, index) in list" :key="index">
      <div class="title">
        <img :src="item.img" alt />
        <span>{{ item.title }}：</span>
      </div>

      <!-- 表格模式啊 -->
      <el-table
        :data="item.tabled"
        style="width: 100%"
        :span-method="objectSpanMethod"
        border
        stripe
      >
        <el-table-column prop="configure" label="装备"></el-table-column>
        <el-table-column prop="materialName" label="名称"></el-table-column>
        <el-table-column
          prop="materialModel"
          label="型号/尺寸"
        ></el-table-column>
        <el-table-column prop="num" label="数量"></el-table-column>
        <el-table-column prop="price" label="单价" v-if="type == 2"></el-table-column>
        <el-table-column prop="allotDate" label="时间" v-if="type == 2"></el-table-column>
        <el-table-column prop="remark" label="备注" v-if="type == 2"></el-table-column>
        <!-- 处理暂无数据时候的 -->
        <!-- <template slot="empty"> -->
        <!-- <noData></noData> -->
        <!-- </template> -->
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardProcessMateriel',
  props: {
    dataDesc: {
      type: Object,
      default: {}
    },
    type: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      list: [
        {
          title: '公司自配装备',
          type: 0,
          projectClothing: [],
          projectMateriel: [],
          projectEquipments: [],
          img: require('@/assets/step/gp.png'),
          tabled: [],
          spanArr: [], // 数组 ，返回的是相对应的行合并行数
          position: 0
        },
        {
          title: '客户配发装备',
          type: 1,
          projectClothing: [],
          projectMateriel: [],
          projectEquipments: [],
          img: require('@/assets/step/zp.png'),
          tabled: [],
          spanArr: [], // 数组 ，返回的是相对应的行合并行数
          position: 0
        }
      ]
    }
  },
  created () {
    this.handleSplitType()
  },
  methods: {
    handleSplitType () {
      this.list[0].projectClothing = this.dataDesc.projectClothing.filter(
        (item) => {
          item.configure = '服装'
          return item.configureType == 0
        }
      )
      this.list[1].projectClothing = this.dataDesc.projectClothing.filter(
        (item) => {
          item.configure = '服装'
          return item.configureType == 1
        }
      )
      this.list[0].projectMateriel = this.dataDesc.projectMateriel.filter(
        (item) => {
          item.configure = '装备'
          return item.configureType == 0
        }
      )
      this.list[1].projectMateriel = this.dataDesc.projectMateriel.filter(
        (item) => {
          item.configure = '装备'
          return item.configureType == 1
        }
      )
      this.list[0].projectEquipments = this.dataDesc.projectEquipments.filter(
        (item) => {
          item.configure = '设备'
          return item.configureType == 0
        }
      )
      this.list[1].projectEquipments = this.dataDesc.projectEquipments.filter(
        (item) => {
          item.configure = '设备'
          return item.configureType == 1
        }
      )

      this._handleConcat(this.list[1])
      this._handleConcat(this.list[0])
    },
    _handleConcat (arr) {
      arr.tabled = [
        ...arr.projectClothing,
        ...arr.projectMateriel,
        ...arr.projectEquipments
      ]
      this.rowspan(arr)
    },
    //  定义每一行的 rowspan
    rowspan (arr) {
      arr.tabled.forEach((item, index) => {
        if (index === 0) {
          arr.spanArr.push(1)
          arr.position = 0
        } else {
          if (arr.tabled[index].configure == arr.tabled[index - 1].configure) {
            arr.spanArr[arr.position] += 1
            arr.spanArr.push(0)
          } else {
            arr.spanArr.push(1)
            arr.position = index
          }
        }
      })
    },
    // 合并单元格
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        var _row = this.list[row.configureType].spanArr[rowIndex]
        var _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  color: #001111;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin: 20px 0 20px;
  img {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}
</style>
};
</script>

<style lang="scss" scoped>
</style>
